import { Link } from "react-router-dom";
import { Star, Truck, ArrowRight } from "lucide-react";

export const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/product/${product.handle}`}
      data-testid={`product-card-${product.id}`}
      className="group block bg-charcoal border border-white/10 overflow-hidden transition-all duration-500 hover:-translate-y-1 hover:shadow-2xl hover:shadow-black/60 hover:border-gold/30"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-espresso">
        <img
          src={product.images[0]}
          alt={product.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3 flex flex-col gap-1.5">
          {product.bestSeller && (
            <span className="bg-gold text-espresso text-[10px] uppercase tracking-wider font-semibold px-2 py-1">
              Best Seller
            </span>
          )}
        </div>
        {product.whiteGlove && (
          <span className="absolute bottom-3 left-3 flex items-center gap-1 bg-espresso/85 text-cream text-[10px] px-2 py-1 backdrop-blur">
            <Truck size={11} className="text-gold" /> White Glove
          </span>
        )}
      </div>
      <div className="p-5">
        <p className="overline text-cream/50">{product.brand}</p>
        <h3 className="font-serif text-lg text-cream mt-1 leading-snug group-hover:text-gold transition-colors">
          {product.title}
        </h3>
        <div className="flex items-center justify-between mt-3">
          <span className="inline-flex items-center gap-1.5 text-gold text-sm font-medium group-hover:gap-2.5 transition-all">
            Request a Quote <ArrowRight size={14} />
          </span>
          {product.rating ? (
            <span className="flex items-center gap-1 text-cream/60 text-xs">
              <Star size={13} className="fill-gold text-gold" /> {product.rating}
            </span>
          ) : null}
        </div>
      </div>
    </Link>
  );
};

